export var FIELD_NAME_SEPARATOR = '.';
export var SCHEMA_VERSION = '1.0.0';
//# sourceMappingURL=Constants.js.map